export { default as AnimatedShorthandPattern } from "./AnimatedShorthandPattern";
